module.exports = __webpack_public_path__ + "img/cliRemover2.14360c9c.jpg";